import { render, staticRenderFns } from "./oss-video.vue?vue&type=template&id=367dbbc0&scoped=true"
import script from "./oss-video.vue?vue&type=script&lang=js"
export * from "./oss-video.vue?vue&type=script&lang=js"
import style0 from "./oss-video.vue?vue&type=style&index=0&id=367dbbc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367dbbc0",
  null
  
)

export default component.exports